import React from 'react';

import useLocation from '../../../../utils/location';
import { ImageLoadingType } from "../../Image/Image";
import { PageSection } from '../../../../ContentfulTypes';

import {
  Wrapper,
  Container,
  Banner,
  BannerCta,
  DesktopBannerImage,
  TabletBannerImage,
  MobileBannerImage,
} from './styles';

interface Props {
  data: PageSection;
  event: string;
  $index: number;
}

const OemBanner = ({ data, event, $index }: Props) => {
  const { pathName } = useLocation();
  if (!data?.combinatorSectionItems?.[0]) return null;

  const banners = (banner, index) => {
    const loading = index === 0 ? ImageLoadingType.Eager : ImageLoadingType.Lazy;
    const desktopImage = banner?.foregroundImageDesktop;
    const tabletImage = banner?.foregroundImageTablet;
    const mobileImage = banner?.foregroundImageMobile;
    return (
      <>
        <DesktopBannerImage image={desktopImage} loading={loading} />
        <TabletBannerImage image={tabletImage} loading={loading} />
        <MobileBannerImage image={mobileImage} loading={loading} />
      </>
    );
  };

  const onHandleClick = () => {
    window.dataLayer = window.dataLayer || [];
    const gtmData = {
      event,
      heroBannerPromotion: data?.combinatorSectionItems?.[0]?.bannerName,
      pageAndPosition: `${pathName} - Position ${$index ? $index + 1 : 1}`,
    };
    window.dataLayer.push(gtmData);
  };
  
  return (
    <Wrapper tabIndex="0" $index={$index} data-testid="feature-banner-section">
      <Container>
        {data?.combinatorSectionItems[0]?.bannerCta ? (
          <BannerCta
            route={`${data?.combinatorSectionItems[0]?.bannerCta.ctaTarget}`}
            url={`${data?.combinatorSectionItems[0]?.bannerCta.ctaUrl}`}
            onHandleClick={onHandleClick}
            data-testid="cta-banner"
            className="cta-banner"
          >
            {banners(data?.combinatorSectionItems[0], 0)}
          </BannerCta>
        ) : (
          <Banner>
            {banners(data?.combinatorSectionItems[0], 0)}
          </Banner>
        )}
      </Container>
    </Wrapper>
  );
};

export default OemBanner;
